import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import commitmentLevelConfig from '../helpers/commitmentLevelConfig';

const CommitmentLevelLabel = ({ commitmentLevel = '' }) => (
  <span className="tickets-index-page__commitment-level-label">
    {commitmentLevelConfig[commitmentLevel].icon}
    {I18n.t(`tickets.commitment_levels.${commitmentLevel}`)}
  </span>
);

CommitmentLevelLabel.propTypes = {
  commitmentLevel: string,
};

export default CommitmentLevelLabel;
